import React, { useState, useEffect, memo } from "react";
import {
  Button,
  ButtonGroup,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  FormControlLabel,
  Checkbox,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Typography,
  Stack,
  RadioGroup,
  FormLabel,
  Radio,
  InputAdornment,
} from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from "@mui/icons-material/Save";
import UpdateIcon from "@mui/icons-material/Update";
import ChallanItemCard from "./ChallanItemCard";
import AlertDialog from "../../Components/AlertDialog/AlertDialog";
import CheckAndReturn from "../../utility/CheckAndReturn";
import { triggerLoader } from "../../redux/reducers/LoaderTrigger";
import Calculation from "../../utility/Calculations";
import configServ from "../../services/config";
import Swal from "sweetalert2";

function ChallanCard({
  isEdit,
  setIsEdit,
  editData,
  clear,
  setIsChanged,
  isChanged,
  isCreate,
  setIsCreate,
  selectedCustomerr,
  productData,
  setProductData,
  setSelectedCustomerr,
  challanData,
  setChallanData,
  billResponse,
  setBillResponse,
  challanDataCopy,
  setChallanDataCopy,
  challanCopy,
  setChallanCopy,
  printpopup,
  entityType = "customer",
}) {
  const dispatch = useDispatch();
  const { user_id, company_id, is_super, is_admin } = useSelector(
    (state) => state.GlobalVariables,
  );

  const [customers, setCustomers] = useState([]);

  const [items, setItems] = useState([]);
  const [autoGenerate, setAutoGenerate] = useState(true);
  const [approval, setApproval] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [title, setTitle] = useState("Alert");
  const [dialogContent, setDialogContent] = useState("");
  const [buttonType, setButtonType] = useState(null);
  const [totalTax, setTotalTax] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalGrossAmount, setTotalGrossAmount] = useState(0);
  const itemListInitial = [
    {
      id: 1,
      itemid: "",
      itemname: "",
      item_code: "",
      packagingunit: "",
      hsn_code: "",
      Taxrate: "",
      qty: "",
      unit: "",
      rate: "",
      tax_amount: "",
      discount: "",
      amount: "",
    },
  ];
  const [itemList, setItemList] = useState(itemListInitial);
  const itemListErrorInitial = [
    {
      itemname: "",
      qty: "",
    },
  ];
  const [itemListError, setItemListError] = useState(itemListErrorInitial);
  const saleOrderInitial = {
    user_id: user_id,
    is_admin: is_admin,
    company_id: company_id,
    auto_generate: true,
    _token: "",
    challan_no: "",
    partyname: "",
    bill_to_address: "",
    ship_to_address: "",
    validitydate: Calculation.GetCurrentDate(),
    sales_order: "",
    salesperson: "",
    purchase_order_no: "",
    totalamount: totalGrossAmount,
    custId: "",
    remarks: "",
    purchase_bill_generated: false,
    purchase_bill_remarks: "",
    purchase_bill_no: "",
    supplier_id: null,

    items: itemList,
  };
  const [saleOrder, setSaleOrder] = useState(saleOrderInitial);

  useEffect(() => {
    if (selectedCustomerr) {
      setSaleOrder((prev) => ({
        ...prev,
        partyname: selectedCustomerr.fname,
        customer_id: selectedCustomerr.id, // ✅ Functional update approach
        bill_to_address: selectedCustomerr.address,
        ship_to_address: selectedCustomerr.address,
      }));
      fetchShipToAddress(selectedCustomerr.id);

      setSelectedCustomerr(null);
    }
  }, [selectedCustomerr]);

  useEffect(() => {
    if (productData && productData.items) {
      const Items = productData.items.map((item) => ({
        order_id: item.order_id,
        company_id: item.company_id,
        itemname: item.item_name,
        packagingunit: item.packagingunit,
        hsn_code: item.hsncode,
        Taxrate: item.tax_rate,
        tax_amount: item.tax_amount || null,
        qty: item.quantity,
        rate: item.rate,
        discount: item.discount,
        amount: item.amount,
        itemid: item.id,
        item_code: item.item_code,
        unit:
          item.product !== null && item.product !== undefined
            ? item.product.unit
            : "",
      }));
      const updatedItemList = CheckAndReturn.UpdateItemList(Items);

      setItemList(updatedItemList);

      // Reset productData to null after successful update
      setProductData(null);
    }
  }, [productData]);

  const saleOrderErrorInitial = {
    partyname: "",
    bill_to_address: "",
    ship_to_address: "",
    validitydate: "",
    delivery_date: "",
    po_number: "",
    purchase_bill_remarks: "",
  };
  const [saleOrderError, setSaleOrderError] = useState(saleOrderErrorInitial);
  const shipToAddressesInitial = [
    {
      id: "",
      address: "",
    },
  ];
  const [shipToAddresses, setShipToAddresses] = useState(
    shipToAddressesInitial,
  );
  const [isOrderAvailable, setIsOrderAvailable] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleOpenDialog = (heading, content, type) => {
    setTitle(heading);
    setDialogContent(content);
    setButtonType(type);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setTitle("Alert");
    setDialogContent("");
    setButtonType(null);
  };

  useEffect(() => {
    if (editData && Object.keys(editData).length !== 0) {
      const supplierName =
        editData.supplier?.contact_name || editData.supplier?.fname || "";
      const customerName = editData.customer?.contact_name || editData.customer?.fname || "";
      const defaultPartyName = entityType === "supplier" ? supplierName : customerName;

      setSaleOrder((prev) => ({
        ...prev,
        id: editData.id, // ✅ IMPORTANT (for update)
        company_id: editData.company_id,
        customer_id: editData.customer_id,
        supplier_id: editData.supplier_id || editData.customer_id,
        partyname: defaultPartyName,
        challan_no: editData.challan_no,
        bill_to_address: editData.bill_to_address,
        ship_to_address: editData.ship_to_address,
        validitydate: editData.challan_date?.split(" ")[0],
        salesperson: editData.reference_name,
        purchase_order_no: editData.purchase_order_no,
        remarks: editData.remarks,
        totalamount: editData.total_amount,
        purchase_bill_generated: editData.purchase_bill_generated || false,
        purchase_bill_remarks: editData.purchase_bill_remarks || "",
        purchase_bill_no: editData.purchase_bill_no || "",
        auto_generate: true,
      }));

      const entityList = Array.isArray(customers) ? customers : [];
      const selectedEntity = entityList.find((cust) =>
        cust.id === (entityType === "supplier" ? editData.supplier_id : editData.customer_id),
      );

      if (selectedEntity) {
        setSaleOrder((prev) => ({
          ...prev,
          partyname: selectedEntity.fname,
        }));
      }

      // ✅ Map Items
      const editItems = editData.items.map((item, index) => ({
        id: index + 1,
        itemid: item.itemid,
        itemname: item.itemname,
        item_code: item.item_code,
        qty: item.qty,
        rate: item.rate,
        amount: item.amount,
      }));

      setItemList(editItems);
      setIsEdit(true);
      fetchShipToAddress(editData.customer_id);
      scrollToTop();
    }
  }, [editData, customers]);

  useEffect(() => {
    if (isCreate) {
      fetchItemList();
      fetchEntityList();
    }
  }, [isCreate]);

  useEffect(() => {
    calculateTotal();
  }, [itemList]);

  useEffect(() => {
    if (!saleOrder.challan_no || saleOrder.auto_generate) return;

    const timer = setTimeout(() => {
      checkOrderNumber();
    }, 500); // 500ms debounce

    return () => clearTimeout(timer); // cleanup
  }, [saleOrder.challan_no]);

  const checkOrderNumber = async () => {
    try {
      const dataToSend = {
        company_id: company_id,
        challan_no: saleOrder.challan_no,
      };
      const res = await configServ.checkChallanNumber(dataToSend);
      if (res.status === 200) {
        setIsOrderAvailable(true);
      } else {
        setIsOrderAvailable(false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const fetchEntityList = async () => {
    try {
      const result = entityType === "supplier"
        ? await configServ.getSupplier({ company_id: company_id })
        : await configServ.get_customer({ company_id: company_id });
      const normalized = Array.isArray(result)
        ? result
        : result?.data ?? [];
      setCustomers(normalized);
    } catch (e) {
      console.log(e);
      setCustomers([]);
    }
  };

  const fetchItemList = async () => {
    try {
      dispatch(triggerLoader());
      const dataToSend = {
        company_id: company_id,
        search_by: null,
        search: null,
        per_page: null,
        page: null,
      };
      const res = await configServ.getItemDropdown(dataToSend);
      if (res.status === 200) {
        if (res.data.length > 0) {
          const result = res.data.filter((x) => x.item_type !== 3); //.filter((x) => x.status === 1);
          setItems(result);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      dispatch(triggerLoader());
    }
  };

  //Sale Order code
  // Handle customer change
  const handleCustomerAutocompleteChange = (newValue) => {
    try {
      if (newValue !== null && newValue !== undefined) {
        handleCustomerInputChange({
          target: { name: "partyname", value: newValue },
        });
      }
    } catch (e) {
      console.log(e);
    }
  };
  // Handle customer input
  const handleCustomerInputChange = (event) => {
    try {
      const customerName = event.target.value;
      const customerList = Array.isArray(customers) ? customers : [];
      const selectedCustomer = customerList.find(
        (item) => item.fname.toLowerCase() === customerName.toLowerCase(),
      );

      if (selectedCustomer !== null && selectedCustomer !== undefined) {
        const updateFields = {
          partyname: selectedCustomer.fname,
          bill_to_address: selectedCustomer.address,
          ship_to_address: selectedCustomer.address,
        };

        if (entityType === "supplier") {
          updateFields.supplier_id = selectedCustomer.id;
        } else {
          updateFields.customer_id = selectedCustomer.id;
        }

        setSaleOrder((prev) => ({
          ...prev,
          ...updateFields,
        }));

        if (entityType !== "supplier") {
          fetchShipToAddress(selectedCustomer.id);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  // Handle Sale Order Customer
  const handleSaleOrderCustomer = (event) => {
    try {
      const { name, value, type, checked } = event.target;

      if (type === "checkbox") {
        setSaleOrder((prev) => ({
          ...prev, //copy existing field values
          [name]: checked, //update field value
        }));
      } else {
        setSaleOrder((prev) => ({
          ...prev, //copy existing field values
          [name]: value, //update field value
        }));
      }

      // Reset the validation error when the user starts typing
      if (saleOrderError[name]) {
        setSaleOrderError((prevValidationError) => ({
          ...prevValidationError,
          [name]: "",
        }));
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handlePurchaseBillGeneratedToggle = async (event) => {
    try {
      const isGenerated = event.target.checked;

      if (isGenerated) {
        const remark = window.prompt(
          "Purchase bill generated. Enter remark note:",
        );

        if (!remark || remark.trim() === "") {
          return;
        }

        setSaleOrder((prev) => ({
          ...prev,
          purchase_bill_generated: true,
          purchase_bill_remarks: remark.trim(),
        }));
      } else {
        setSaleOrder((prev) => ({
          ...prev,
          purchase_bill_generated: false,
          purchase_bill_remarks: "",
        }));
      }
    } catch (e) {
      console.log(e);
    }
  };

  //Fetch Ship To Address
  const fetchShipToAddress = async (cust_id) => {
    try {
      const result = await configServ.getShipToAddress({ cust_id: cust_id });
      setShipToAddresses(result);
    } catch (e) {
      console.log(e);
    }
  };

  const calculateTotal = () => {
    let total_Quantity = 0;
    let totalAmount = 0;

    itemList.forEach((item) => {
      const quantity = parseFloat(item.qty) || 0;
      const rate = parseFloat(item.rate) || 0;
      const amount = quantity * rate;

      total_Quantity += quantity;
      totalAmount += amount;
    });

    setTotalQuantity(total_Quantity);
    setTotalGrossAmount(totalAmount);

    setSaleOrder((prev) => ({
      ...prev,
      totalamount: totalAmount,
    }));
  };

  const handleAutocompleteChange = (newValue, id) => {
    const value = newValue || ""; // Handle possible undefined or null values
    handleInputChange({ target: { name: "itemname", value } }, id);
  };

  const handleInputChange = (event, id) => {
    try {
      const { name, value } = event.target;

      const currentItem = itemList.find((item) => item.id === id);
      if (!currentItem) return;

      const updatedItem = {
        ...currentItem,
        [name]: value,
      };

      // 🔥 Simple Calculation (No GST, No Discount)
      if (name === "qty" || name === "rate") {
        const qty = parseFloat(updatedItem.qty) || 0;
        const rate = parseFloat(updatedItem.rate) || 0;
        updatedItem.amount = (qty * rate).toFixed(2);
      }

      // 🔥 When Item Selected → Put billable_rate
      if (name === "itemname") {
        const selectedItem = items.find(
          (item) => item.item_name.toLowerCase() === value.toLowerCase(),
        );

        if (selectedItem) {
          Object.assign(updatedItem, {
            itemid: selectedItem.id,
            itemname: selectedItem.item_name,
            item_code: selectedItem.item_code,
            packagingunit: selectedItem.packagingunit,
            hsn_code: selectedItem.hsncode,
            unit: selectedItem.unit,
            qty: "",
            rate: selectedItem.billable_rate || 0, // ✅ BILLABLE RATE
            amount: "0",
          });
        } else {
          Object.assign(updatedItem, {
            itemid: "",
            item_code: "",
            packagingunit: "",
            hsn_code: "",
            unit: "",
            qty: "",
            rate: "",
            amount: "0",
          });
        }
      }

      const updatedItemList = itemList.map((item) =>
        item.id === id ? updatedItem : item,
      );

      setItemList(updatedItemList);
    } catch (e) {
      console.log(e);
    }
  };

  // Function to add a new item to the list right after the current item
  const handleAddItem = (currentItemId) => {
    try {
      setItemList((prevList) => {
        // Check if the list is empty
        if (prevList.length === 0) {
          // Return the list with the first item if it's empty
          return [
            {
              id: 1,
              name: "",
              qty: "",
            },
          ];
        }

        // Find the index of the current item
        const currentIndex = prevList.findIndex(
          (item) => item.id === currentItemId,
        );

        // Handle case when currentItemId is not found
        if (currentIndex === -1) {
          console.log(`Item with id ${currentItemId} not found.`);
          return prevList; // Return the original list without changes
        }

        // Create new item
        const newItem = {
          id: Math.max(...prevList.map((item) => item.id)) + 1, // New ID
          name: "",
          qty: "",
        };

        // Insert new item right after the current item
        return [
          ...prevList.slice(0, currentIndex + 1), // Items before and including the current item
          newItem, // New item to be added
          ...prevList.slice(currentIndex + 1), // Items after the current item
        ];
      });
    } catch (e) {
      console.log(e);
    }
  };

  // Function to delete an item from the list based on its ID
  const handleDeleteItem = (data) => {
    try {
      // Check if the data object is valid
      if (data !== null && data !== undefined) {
        const id = data.id;

        setItemList((prevList) => {
          // If there's more than one item, remove the selected one
          if (prevList.length > 1) {
            return prevList.filter((item) => item.id !== id);
          }

          // If only one item is left, reset to the initial state
          else if (prevList.length === 1) {
            return itemListInitial; // Assuming `itemListInitial` is your default list
          }

          return prevList; // Return the same list if no changes
        });
      } else {
        console.log("Invalid data object passed to handleDeleteItem.");
      }
    } catch (e) {
      console.log(e);
    }
  };

  const navigate = useNavigate();

  // Reset
  const handleReset = () => {
    setSaleOrder(saleOrderInitial);
    setSaleOrderError(saleOrderErrorInitial);
    setItemList(itemListInitial);
    setItemListError(itemListErrorInitial);
    setIsOrderAvailable(false);
    clear();
    setIsEdit(false);
    setChallanData(null);
    setBillResponse(null);
    setChallanDataCopy(null);
    setChallanCopy(null);
    // ✅ Clear router state cleanly
    navigate(".", { replace: true, state: null });
  };

  const fetchConfig = async () => {
    try {
      const res = await configServ.getConfiguration({
        company_id: company_id,
      });

      if (res.status === 200) {
        return Boolean(res.data.challan_pop);
      }

      return false;
    } catch (e) {
      console.log(e);
      return false;
    }
  };

  // console.log("showPop", showPop)

  // Save
  const handleSubmit = async () => {
    try {
      dispatch(triggerLoader());

      const saleOrderErrors = await validateSaleOrder();
      const itemListErrors = await validateItemList();
      if (
        Object.keys(saleOrderErrors).length > 0 ||
        Object.keys(itemListErrors).length > 0 ||
        (isOrderAvailable === false && saleOrder.auto_generate === false)
      ) {
        // Handle the errors as needed (e.g., show error messages, prevent saving, etc.)
        return; // Return early if there are errors
      }

      saleOrder.items = await handleSaleOrderItemList();
      const payload = {
        ...saleOrder,
        supplier_id:
          entityType === "supplier"
            ? saleOrder.customer_id || saleOrder.supplier_id
            : undefined,
      };

      if (!isEdit) {
        const res =
          entityType === "supplier"
            ? await configServ.createVendorChallan(payload)
            : await configServ.createChallanOrder(payload);

        if (res.success === true) {
          clear();
          const shouldPrint = await fetchConfig();

          if (shouldPrint) {
            printpopup(res.data);
          }
          handleReset();
          setIsChanged(!isChanged);
          setIsCreate(false);
          handleOpenDialog(
            "Success",
            res.message ||
              (entityType === "supplier"
                ? "Job Work created successfully."
                : "Challan created successfully."),
            "success",
          );
        } else if (res.success === false) {
          if (res.message === "Previous vendor challan is still pending purchase bill generation for this supplier.") {
            Swal.fire({
              title: "Purchase Bill Pending",
              text: res.message,
              icon: "warning",
              confirmButtonText: "OK",
              confirmButtonColor: "#ff9800",
            });
          } else {
            handleOpenDialog(
              "Error",
              res.message ||
                (entityType === "supplier"
                  ? "Failed to create Job Work."
                  : "Failed to create challan order."),
              "error",
            );
          }
        } else {
          handleOpenDialog(
            "Error",
            res.message ||
              (entityType === "supplier"
                ? "Failed to create Job Work."
                : "Failed to create challan order."),
            "error",
          );
        }
      } else {
        const res =
          entityType === "supplier"
            ? await configServ.updateVendorChallan(saleOrder.id, payload)
            : await configServ.updateChallanOrder(saleOrder.id, payload);
        if (res.success === true) {
          clear();
          // printpopup(res.data);
          const shouldPrint = await fetchConfig();

          if (shouldPrint) {
            printpopup(res.data);
          }
          setIsCreate(false);
          handleReset();
          setIsChanged(!isChanged);
          handleOpenDialog(
            "Success",
            res.message ||
              (entityType === "supplier"
                ? "Job Work updated successfully."
                : "Challan updated successfully."),
            "success",
          );
        } else if (res.success === false) {
          handleOpenDialog(
            "Error",
            res.message ||
              (entityType === "supplier"
                ? "Failed to update Job Work."
                : "Failed to update sales order."),
            "error",
          );
        } else {
          handleOpenDialog(
            "Error",
            res.message ||
              (entityType === "supplier"
                ? "Failed to update Job Work."
                : "Failed to update sales order."),
            "error",
          );
        }
      }
    } catch (e) {
      console.log(e);
      handleOpenDialog("Error", "An unexpected error has occurred.", "error");
    } finally {
      dispatch(triggerLoader());
    }
  };

  const handleSaleOrderItemList = async () => {
    try {
      return itemList.map((item) => ({
        itemname: item.itemname,
        itemid: item.itemid,
        item_code: item.item_code,
        packagingunit: item.packagingunit,
        hsn_code: item.hsn_code,
        qty: item.qty,
        rate: item.rate,
        amount: item.amount,
      }));
    } catch (e) {
      console.log(e);
    }
  };

  // Validate the Sale Order fields
  const validateSaleOrder = async () => {
    const errors = {};

    const entityLabel = entityType === "supplier" ? "Supplier" : "Customer";
    const entityIdField = entityType === "supplier" ? "supplier_id" : "customer_id";

    if (!saleOrder[entityIdField]) {
      errors.partyname = `${entityLabel} Name is required.`;
    }
    if (!saleOrder.bill_to_address) {
      errors.bill_to_address = "Bill To Address is required.";
    }
    if (!saleOrder.ship_to_address || saleOrder.ship_to_address === "") {
      errors.ship_to_address = "ShipTo Address is required.";
    }
    if (saleOrder.purchase_bill_generated && !saleOrder.purchase_bill_remarks) {
      errors.purchase_bill_remarks = "Purchase bill remark is required when bill is generated.";
    }

    setSaleOrderError(errors);

    return errors;
  };

  // Validate ItemList
  const validateItemList = async () => {
    const errors = itemList.map((item) => ({
      itemname: !item.itemname ? "Item Name is required." : "",
      qty: !item.qty ? "Quantity is required." : "",
      // Add additional validations for other item fields as needed...
    }));

    setItemListError(errors);
    const hasErrors = errors.some((error) => error.itemname || error.qty);
    return hasErrors ? errors : {};
  };

  const handleCut = () => {
    handleReset();
    setIsCreate(!isCreate);
  };

  const highlightMatch = (text = "", query = "") => {
    const safeText = text == null ? "" : String(text);
    const safeQuery = query == null ? "" : String(query);

    try {
      if (!safeText) return safeText;
      if (!safeQuery) return safeText;

      const words = safeQuery.toLowerCase().split(" ").filter(Boolean);
      if (!words.length) return safeText;

      const escapedWords = words.map((word) =>
        word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
      );
      const regex = new RegExp(`(${escapedWords.join("|")})`, "gi");

      return safeText.split(regex).map((part, index) => {
        const partText = part ?? "";
        if (!partText) {
          return <React.Fragment key={index} />;
        }
        return words.includes(partText.toLowerCase()) ? (
          <mark key={index} style={{ backgroundColor: "#ffe58f", padding: 0 }}>
            {partText}
          </mark>
        ) : (
          <React.Fragment key={index}>{partText}</React.Fragment>
        );
      });
    } catch (e) {
      console.error("Error in highlightMatch:", e);
      return safeText;
    }
  };

  useEffect(() => {
    if (challanData && items.length > 0) {
      setSaleOrder((prev) => ({
        ...prev,
        company_id: challanData.company_id,
        purchase_order_no: billResponse.purchase_bill_no,
        remarks: challanData.billing_note,
        salesperson: challanData?.suppliers?.contact_name,
        auto_generate: true,
      }));

      const mappedItems = challanData.items
        .map((item, index) => {
          const selectedProduct = items.find(
            (prod) => Number(prod.id) === Number(item.item_id),
          );

          if (!selectedProduct) return null;

          const qty = parseFloat(item.quantity) || 0;
          const rate = parseFloat(selectedProduct.billable_rate) || 0;
          const amount = qty * rate;

          return {
            id: index + 1,
            itemid: selectedProduct.id,
            itemname: selectedProduct.item_name,
            item_code: selectedProduct.item_code,
            packagingunit: selectedProduct.packagingunit,
            hsn_code: selectedProduct.hsncode,
            unit: selectedProduct.unit,
            qty: qty,
            rate: rate,
            amount: amount.toFixed(2),
          };
        })
        .filter(Boolean); // remove null values

      setItemList(mappedItems);
    }
  }, [challanData, items]);

  useEffect(() => {
    if (challanDataCopy && items.length > 0) {
      setSaleOrder((prev) => ({
        ...prev,
        company_id: challanDataCopy.company_id,
        purchase_order_no: challanDataCopy.purchase_bill_no,
        remarks: challanDataCopy.billing_note,
        salesperson: challanDataCopy?.suppliers?.contact_name,
        auto_generate: true,
      }));

      const mappedItems = challanDataCopy.items
        .map((item, index) => {
          const selectedProduct = items.find(
            (prod) => Number(prod.id) === Number(item.item_id),
          );

          if (!selectedProduct) return null;

          const qty = parseFloat(item.quantity) || 0;
          const rate = parseFloat(selectedProduct.billable_rate) || 0;
          const amount = qty * rate;

          return {
            id: index + 1,
            itemid: selectedProduct.id,
            itemname: selectedProduct.item_name,
            item_code: selectedProduct.item_code,
            packagingunit: selectedProduct.packagingunit,
            hsn_code: selectedProduct.hsncode,
            unit: selectedProduct.unit,
            qty: qty,
            rate: rate,
            amount: amount.toFixed(2),
          };
        })
        .filter(Boolean); // remove null values

      setItemList(mappedItems);
    }
  }, [challanDataCopy, items]);

  useEffect(() => {
    if (challanCopy && items.length > 0) {
      setSaleOrder((prev) => ({
        ...prev,
        company_id: challanCopy.company_id,
        customer_id: challanCopy.customer_id,
        purchase_order_no: challanCopy?.purchase_bill_no,
        remarks: challanCopy.remarks,
        salesperson: challanCopy?.reference_name,
        auto_generate: true,
      }));

      const mappedItems = challanCopy.items
        .map((item, index) => {
          const selectedProduct = items.find(
            (prod) => Number(prod.id) === Number(item.itemid),
          );

          if (!selectedProduct) return null;

          const qty = parseFloat(item.qty) || 0;
          const rate = parseFloat(selectedProduct.billable_rate) || 0;
          const amount = qty * rate;

          return {
            id: index + 1,
            itemid: selectedProduct.id,
            itemname: selectedProduct.item_name,
            item_code: selectedProduct.item_code,
            packagingunit: selectedProduct.packagingunit,
            hsn_code: selectedProduct.hsncode,
            unit: selectedProduct.unit,
            qty: qty,
            rate: rate,
            amount: amount.toFixed(2),
          };
        })
        .filter(Boolean); // remove null values

      setItemList(mappedItems);
    }
  }, [challanCopy, items]);

  //#endregion

  return (
    <Box>
      <AlertDialog
        open={dialogOpen}
        setOpen={handleCloseDialog}
        title={title}
        message={dialogContent}
        buttonTitle="Ok"
        buttonType={buttonType}
      />

      <motion.div
        style={{
          width: "100%",
          backgroundColor: "#e3f3fc",
          padding: 20,
          borderRadius: "10px",
          border: "none",
          margin: "10px",
        }}
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.1, delay: 0.1 }}
      >
        {/* <Button onClick={abc}>abc</Button> */}
        <Grid
          container
          alignItems="flex-end"
          justifyContent="space-between"
          //sx={{ p: 10 }}
          spacing={1}
        >
          {/* Left side: PersonAddIcon */}
          <Grid item xs={6} md={6}></Grid>

          {/* Right side: Reset and Update buttons */}
          <Grid
            container
            item
            xs={6}
            md={6}
            alignItems={"center"}
            justifyContent={"flex-end"}
          >
            <Stack direction={"row"} spacing={1}>
              {isEdit ? (
                <>
                  <IconButton
                    onClick={handleCut}
                    sx={{
                      borderRadius: 2, // Rounded corners
                      px: 2, // Horizontal padding
                      py: 1, // Vertical padding
                      backgroundColor: "red", // Base red background
                      color: "white", // Icon color
                      "&:hover": {
                        backgroundColor: "darkred", // Darker red on hover for better contrast
                      },
                      boxShadow: 2, // Add a subtle shadow for depth
                      ml: 1, // Margin left to separate from other elements
                      transition: "all 0.3s ease", // Smooth transition for hover effect
                    }}
                    title="cut"
                  >
                    <CancelIcon sx={{ fontSize: 18 }} />{" "}
                    {/* Slightly larger icon for better visibility */}
                  </IconButton>
                </>
              ) : (
                <>
                  {" "}
                  <IconButton
                    onClick={handleReset}
                    sx={{
                      borderRadius: 2,
                      px: 2, // Horizontal padding
                      py: 1, // Vertical padding
                      backgroundColor: "secondary.main", // Use theme secondary color
                      color: "white", // Icon color
                      "&:hover": {
                        backgroundColor: "secondary.dark", // Darker shade on hover
                      },
                      ml: 1, // Margin left to separate from other elements
                    }}
                    title="Reset"
                  >
                    <RotateLeftIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </>
              )}

              <IconButton
                size="small"
                onClick={handleSubmit}
                sx={{
                  borderRadius: 2,
                  px: 2, // Horizontal padding
                  py: 1, // Vertical padding
                  backgroundColor: isEdit ? "success.main" : "primary.main", // Use theme primary color
                  color: "white", // Icon color
                  "&:hover": {
                    backgroundColor: isEdit ? "success.dark" : "primary.dark", // Darker shade on hover
                  },
                }}
                title={isEdit ? "Update" : "Save"}
              >
                {<SaveIcon sx={{ fontSize: 16 }} />}
              </IconButton>
            </Stack>
          </Grid>
        </Grid>

        {/* Next line of content starts here */}
        <Grid
          container
          alignItems="flex-end"
          justifyContent="flex-start"
          sx={{ px: 1 }}
          spacing={1}
        >
          <Grid item xs={12} sm={6} md={3}>
            <Stack direction={"column"}>
              <Link
                to={
                  entityType === "supplier"
                    ? "/account-master-entry/supplier"
                    : "/account-master-entry/customers"
                }
              >
                <Tooltip
                  title={
                    entityType === "supplier"
                      ? "Add supplier"
                      : "Add customer"
                  }
                >
                  <PersonAddIcon
                    sx={{
                      cursor: "pointer",
                      color: "white",
                      backgroundColor: "grey",
                      margin: "2px",
                    }}
                    justifyContent="flex-end"
                  />
                </Tooltip>
              </Link>
              <Autocomplete
                id="grouped-demo"
                size="small"
                sx={{ backgroundColor: "white" }}
                value={
                  (Array.isArray(customers) ? customers : []).find(
                    (customer) =>
                      customer.id ===
                      (entityType === "supplier"
                        ? saleOrder.supplier_id
                        : saleOrder.customer_id),
                  ) || null
                }
                options={Array.isArray(customers) ? customers : []}
                getOptionLabel={(option) =>
                  option.fname && option.address
                    ? `${
                        option.fname
                      } (${CheckAndReturn.checkTextNullAndUndefined(
                        option.address,
                      )})`
                    : `${option.fname}`
                }
                isOptionEqualToValue={(option, value) => option.id === value.id}
                filterOptions={(options, { inputValue }) => {
                  const words = (inputValue || "")
                    .toLowerCase()
                    .split(" ")
                    .filter(Boolean);
                  return options.filter((customer) => {
                    const fname = customer?.fname?.toLowerCase?.() || "";
                    const address = customer?.address?.toLowerCase?.() || "";
                    return words.every(
                      (word) => fname.includes(word) || address.includes(word),
                    );
                  });
                }}
                onChange={(event, newValue) => {
                  if (newValue) {
                    handleCustomerAutocompleteChange(newValue.fname);
                  } else {
                    handleCustomerAutocompleteChange("");
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      entityType === "supplier"
                        ? "Supplier Name"
                        : "Customer Name"
                    }
                    fullWidth
                    size="small"
                    autoFocus
                    value={saleOrder.partyname || ""}
                    onChange={handleCustomerInputChange}
                    error={!!saleOrderError.partyname}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        const value = e.target.value;
                        const customerList = Array.isArray(customers)
                          ? customers
                          : [];
                        const selectedCustomer = customerList.find(
                          (cust) => cust.fname === value,
                        );
                        if (selectedCustomer) {
                          handleCustomerAutocompleteChange(
                            selectedCustomer.fname,
                          );
                        }
                      }
                    }}
                  />
                )}
                renderOption={(props, option, { inputValue = "" }) => (
                  <li {...props}>
                    <Box
                      sx={{
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        maxWidth: "100%",
                      }}
                    >
                      <Typography variant="body2" fontWeight={500}>
                        {highlightMatch(option?.fname || "", inputValue)}
                      </Typography>
                      {option?.address && (
                        <Typography variant="caption" color="text.secondary">
                          {highlightMatch(option?.address || "", inputValue)}
                        </Typography>
                      )}
                    </Box>
                  </li>
                )}
              />
            </Stack>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Bill To Address"
              variant="outlined"
              fullWidth
              size="small"
              name="bill_to_address"
              value={saleOrder.bill_to_address}
              onChange={handleSaleOrderCustomer}
              sx={{ backgroundColor: "white" }}
              error={!!saleOrderError.bill_to_address}
              InputLabelProps={{
                shrink: saleOrder.bill_to_address ? true : false,
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <FormControlLabel
              control={<Checkbox />}
              label="Auto Generate"
              name="auto_generate"
              checked={!!saleOrder.auto_generate}
              onChange={handleSaleOrderCustomer}
            />
            <TextField
              variant="outlined"
              fullWidth
              size="small"
              label="Job Work No"
              placeholder="CHA0001 (Sample)"
              sx={{ backgroundColor: "white" }}
              disabled={!!saleOrder.auto_generate}
              name="challan_no"
              value={saleOrder.challan_no}
              onChange={handleSaleOrderCustomer}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {saleOrder.auto_generate || isOrderAvailable ? (
                      <CheckCircleIcon color="success" />
                    ) : (
                      <CancelIcon color="error" />
                    )}
                  </InputAdornment>
                ),
              }}
              error={
                !!(
                  isOrderAvailable === false &&
                  saleOrder.auto_generate === false
                )
              }
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label=" Date"
              variant="outlined"
              type="date"
              fullWidth
              size="small"
              name="validitydate"
              value={saleOrder.validitydate}
              onChange={handleSaleOrderCustomer}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
              error={!!saleOrderError.validitydate}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6}>
            <TextField
              label="Ref. Name"
              variant="outlined"
              fullWidth
              size="small"
              name="salesperson"
              value={saleOrder.salesperson}
              onChange={handleSaleOrderCustomer}
              sx={{ backgroundColor: "white" }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6}>
            <TextField
              label="Reference Bill No."
              variant="outlined"
              fullWidth
              size="small"
              name="purchase_order_no"
              value={saleOrder.purchase_order_no}
              onChange={handleSaleOrderCustomer}
              sx={{ backgroundColor: "white" }}
            />
          </Grid>

          {entityType === "supplier" && isEdit && (
            <Grid item xs={12} sm={6} md={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="purchase_bill_generated"
                    checked={!!saleOrder.purchase_bill_generated}
                    onChange={handlePurchaseBillGeneratedToggle}
                  />
                }
                label="Purchase Bill Generated"
              />
              {saleOrder.purchase_bill_generated && (
                <TextField
                  variant="outlined"
                  fullWidth
                  size="small"
                  label="Purchase Bill Remark"
                  name="purchase_bill_remarks"
                  value={saleOrder.purchase_bill_remarks}
                  onChange={handleSaleOrderCustomer}
                  error={!!saleOrderError.purchase_bill_remarks}
                  sx={{ backgroundColor: "white", mt: 1 }}
                />
              )}
            </Grid>
          )}
        </Grid>

        <Grid
          container
          alignItems="flex-end"
          justifyContent="flex-start"
          style={{ padding: 10 }}
          spacing={1}
        >

          <Grid item xs={12} sm={6} md={6}>
            <TextField
              label="Remarks"
              variant="outlined"
              placeholder="Leave a comment here"
              multiline
              rows={2}
              fullWidth
              size="small"
              name="remarks"
              value={saleOrder.remarks}
              onChange={handleSaleOrderCustomer}
              sx={{ backgroundColor: "white" }}
            />
          </Grid>
        </Grid>

        <ChallanItemCard
          itemList={itemList}
          handleAutocompleteChange={handleAutocompleteChange}
          handleInputChange={handleInputChange}
          handleAddItem={handleAddItem}
          handleDeleteItem={handleDeleteItem}
          items={items}
          errors={itemListError}
          with_gst={saleOrder.with_gst}
        />

        <Grid container xs={12} md={12} alignItems={"center"}>
          <Grid
            container
            item
            xs={12}
            md={4}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Typography variant="body1" sx={{ color: "green" }}>
              Quantity: {totalQuantity ? totalQuantity : 0}
            </Typography>
          </Grid>

          <Grid
            container
            item
            xs={12}
            md={4}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Typography variant="body1" sx={{ color: "green" }}>
              Gross Amount: ₹{totalGrossAmount ? totalGrossAmount : 0}
            </Typography>
          </Grid>
          <Grid
            container
            item
            xs={12}
            md={12}
            alignItems={"center"}
            justifyContent={"flex-end"}
          >
            <IconButton
              size="small"
              onClick={handleSubmit}
              sx={{
                borderRadius: 2,
                px: 2, // Horizontal padding
                py: 1, // Vertical padding
                backgroundColor: isEdit ? "success.main" : "primary.main", // Use theme primary color
                color: "white", // Icon color
                "&:hover": {
                  backgroundColor: isEdit ? "success.dark" : "primary.dark", // Darker shade on hover
                },
              }}
              title={isEdit ? "Update" : "Save"}
            >
              <SaveIcon sx={{ fontSize: 22 }} />
            </IconButton>
          </Grid>
        </Grid>
      </motion.div>
    </Box>
  );
}

export default memo(ChallanCard);
